import { partnerTerms, stripFrontmatter } from "@biteasy/legal";
import Markdown from "react-markdown";
import { Button } from "@/components/catalyst/Button";
import { Checkbox, CheckboxField } from "@/components/catalyst/Checkbox";
import { Label } from "@/components/catalyst/Fieldset";
import { Heading, Subheading } from "../../../components/catalyst/Heading";

const partnerTermsContent = stripFrontmatter(partnerTerms);

interface TermsStateProps {
	partnerName: string;
	termsAccepted: boolean;
	setTermsAccepted: (value: boolean) => void;
	isAccepting: boolean;
	onAccept: () => void;
	onDecline: () => void;
}

export function TermsState({
	partnerName,
	termsAccepted,
	setTermsAccepted,
	isAccepting,
	onAccept,
	onDecline,
}: TermsStateProps) {
	return (
		<div className="flex flex-col gap-6 w-full">
			<div className="flex flex-col gap-2">
				<Heading>Partner Agreement</Heading>
				<Subheading>
					Hi {partnerName}, please review and accept the terms to continue.
				</Subheading>
			</div>

			<div className="h-96 overflow-y-auto border border-base-300 rounded-lg p-6 text-left bg-base-200/50 prose prose-sm prose-invert max-w-none prose-headings:text-base-content prose-p:text-base-content/80 prose-strong:text-base-content prose-li:text-base-content/80 prose-li:marker:text-accent prose-a:text-accent prose-a:no-underline hover:prose-a:underline">
				<Markdown>{partnerTermsContent}</Markdown>
			</div>

			<CheckboxField>
				<Checkbox
					checked={termsAccepted}
					onChange={setTermsAccepted}
					color="indigo"
				/>
				<Label className="font-semibold">
					I have read and agree to the Partner Terms of Service
				</Label>
			</CheckboxField>

			<div className="flex gap-4">
				<Button
					color="dark/white"
					disabled={!termsAccepted || isAccepting}
					onClick={onAccept}
					className="flex-1"
				>
					{isAccepting ? "Processing..." : "Accept & Continue"}
				</Button>
				<Button
					color="white"
					onClick={onDecline}
					className="flex-1"
					disabled={isAccepting}
				>
					Decline
				</Button>
			</div>
		</div>
	);
}
